/*
* 默认头部菜单配置
* */
export default {
  strong : true,
  italic : true,
  overline : true,
  h1 : true,
  h2 : true,
  h3 : true,
  h4 : false,
  h5 : false,
  h6 : false,
  hr : true,
  quote : true,
  ul : true,
  ol : true,
  code : true,
  link : true,
  image : true,
  table : true,
  checked : true,
  notChecked : true,
  shift : true,
  fullscreen : true,
  print : false,
  theme : true,
  exportmd : true,
  importmd : true
}



// WEBPACK FOOTER //
// ./src/markdown/js/tools.js